// Module
var code = "<div class=\"step_loading\" style=\"display: none;\">\n  <div class=\"icon_font\">Loading...</div>\n</div>\n<div class=\"step_form\">\n  <h3></h3>\n  <div class=\"step_form_inputs\">\n    <button>&lt;</button><input /><button>&gt;</button>\n  </div>\n  <div class=\"step_form_extra\"></div>\n  <div class=\"err_msg\"></div>\n</div>\n";
// Exports
module.exports = code;